import { Box, Stack } from "@mui/system";

import { spacing } from "../../../../../../../../../../../assets/styles/tokens";
import {
  formatDate,
  formatCurrency,
  formatPercent,
} from "../../../../../../../../../../AssetManagement/Overview/BusinessLeaderDashboard/BizLeaderMobileDashboard/helpers/roundFunctions";
import AccountSummeryPerformanceCard from "./AccountSummeryPerformanceCard";

const AccountSummeryPerformance = ({ sortedData }: any) => {
  const getRoiColor = (roi: number) => {
    if (roi < 0.5) return "error";
    if (roi > 0.9) return "success";
    return "warning";
  };
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.lg1.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <AccountSummeryPerformanceCard
              key={index}
              date={formatDate(item.start_of_week || item.date || item.month)}
              cac={formatCurrency(item.cac)}
              cpaPV={formatCurrency(item.cpa_pv)}
              qftd={formatCurrency(item.cpa_pv_qftd)}
              ClickIn={formatCurrency(item.epc_click_in)}
              roiPercentage={formatPercent(item.roi_perc)}
              roiColor={getRoiColor(item.roi_perc)}
              rs={formatPercent(item.rs_perc_from_total_income)}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default AccountSummeryPerformance;
